export default __webpack_public_path__ + "5f7f4ee51e03a9c04ef515ef622d2315.svg";